import { render } from "./TokenPaymentError.vue?vue&type=template&id=f0726112&scoped=true"
import script from "./TokenPaymentError.vue?vue&type=script&lang=js"
export * from "./TokenPaymentError.vue?vue&type=script&lang=js"

import "./TokenPaymentError.vue?vue&type=style&index=0&id=f0726112&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0726112"]])

export default __exports__